import React from 'react'
import { connect } from 'react-redux'
import { ReduxState } from '../redux/store'
import { Actions } from '../redux/CSSVariables'
import ButtonsPage from './ButtonsPage'

const mapStateToProps = (state: ReduxState) => ({ ...state.CSSVariables })

const mapDispatchToProps = {
  setCSSVariable: Actions.setCSSVariable,
}

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps
function ButtonsPageContainer(props: Props) {
  return <ButtonsPage {...props} />
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ButtonsPageContainer)
